module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS7.d4ba7945.jpg";